import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

export function provideTranslocoScopeFactoryContact(): Provider {
  return provideTranslocoScope({
    scope: 'shared-factory-contact',
    alias: 'factoryContact',
    loader: i18nLoader,
  });
}
